import React from 'react';
import { TipseenContent, TipseenTrigger, TipseenWrapper } from './style';

function Tipseen({
  fowardRef,
  trigger,
  content,
  handleShow,
  show,
  hover,
  placement,
}) {
  return (
    <TipseenWrapper
      onMouseEnter={hover && handleShow}
      onMouseLeave={hover && handleShow}
    >
      <TipseenContent placement={placement} ref={fowardRef} show={show}>
        {content}
      </TipseenContent>
      <TipseenTrigger onClick={handleShow}>{trigger}</TipseenTrigger>
    </TipseenWrapper>
  );
}

export default Tipseen;
